<template>
	<v-container class="noMargin">
		<v-layout row wrap>					
			<v-flex lg12>
				<div class="pageTitle">
					<h2>SPEC REPORTS</h2>					
				</div>

                <v-btn @click.prevent="fncExportQuotes" class="elevation-5" color="info"><i class="material-icons">close</i>EXPORT TO CSV</v-btn>
				<v-btn @click.prevent="fncShowFilter" class="elevation-5" color="info"><i class="material-icons">filter_list</i>FILTER / GENERATE REPORT</v-btn>                
				<v-btn @click.prevent="fncReloadQuotes" class="elevation-5" color="info"><i class="material-icons reloadButton">refresh</i></v-btn>
			</v-flex>
		</v-layout>		
	</v-container>	
</template>

<script>
    import { mapGetters } from 'vuex';
	export default {
		name: 'RoleHeader',
		data () {
			return {			
              columnLengths: [],
              objCustomerRegion: window.localStorage.qRegion != undefined && window.localStorage.qRegion[0] != null ? window.localStorage.qRegion.split(',') : '',
              objOriginator: window.localStorage.qOriginator != undefined && window.localStorage.qOriginator[0] != null ? window.localStorage.qOriginator.split(',') : '',
              objStatus: window.localStorage.qStatus != undefined && window.localStorage.qStatus[0] != null ? window.localStorage.qStatus.split(',') : '',
              objCustomerCompany: window.localStorage.qCompany != undefined && window.localStorage.qCompany[0] != null ? window.localStorage.qCompany.split(',') : '',
              objCustomerUser: window.localStorage.qCustomer != undefined && window.localStorage.qCustomer[0] != null ? window.localStorage.qCustomer.split(',') : '',
              objProject: window.localStorage.qProject != undefined && window.localStorage.qProject[0] != null ? window.localStorage.qProject.split(',') : '',
              objSpecifier: window.localStorage.qSpecifier != undefined && window.localStorage.qSpecifier[0] != null ? window.localStorage.qSpecifier.split(',') : '',
              startDate: window.localStorage.qStartDate,
              endDate: window.localStorage.qEndDate
			}		
		},
		methods: {
			fncShowFilter() {
				var modalDetails = { title: 'Generate / Filter Report', component: 'modal-filter-quotes', mstate: true, params: {} };			
				this.$store.commit({
					type: 'setModal',
					details: modalDetails
				});
          },
            fncShowColumns() {
              var modalDetails = { title: 'Filter Columns', component: 'modal-filter-columns', mstate: true, params: {} };
              this.$store.commit({
                type: 'setModal',
                details: modalDetails
              });
            },
            fncReloadQuotes() {
              this.$store.commit('fncEmptyQuoteList');
              this.$store.dispatch({
                type: 'fncPopulateQuoteList',
                date_from: this.startDate == '' || this.startDate == undefined ? 'null' : this.startDate,
                date_to: this.endDate == '' || this.endDate == undefined ? 'null' : this.endDate,
                region: this.objCustomerRegion == '' || this.objCustomerRegion[0] == 'null' ? 'null' : this.objCustomerRegion,
                status: this.objStatus == '' || this.objStatus[0] == 'null' ? 'null' || this.objStatus[0] == 'null' : this.objStatus,
                originator: this.objOriginator == '' || this.objOriginator[0] == 'null' || this.objOriginator[0] == 'null' ? 'null' : this.objOriginator,
                customer: this.objCustomerUser == '' || this.objCustomerUser[0] == 'null' || this.objCustomerUser[0] == 'null' ? 'null' : this.objCustomerUser,
                project: this.objProject == '' || this.objProject[0] == 'null' || this.objProject[0] == 'null' ? 'null' : this.objProject,
                company: this.objCustomerCompany == '' || this.objCustomerCompany[0] == 'null' || this.objCustomerCompany[0] == 'null' ? 'null' : this.objCustomerCompany,
                specifier: this.objSpecifier == '' || this.objSpecifier[0] == 'null' || this.objSpecifier[0] == 'null' ? 'null' : this.objSpecifier,
                reload: true
              })
            },
            fncExportQuotes() {
              var reportData = 'QUOTE DATE, QUOTE NO., ORIGINATOR TYPE, ORIGINATOR, CUSTOMER TYPE, CUSTOMER, CUSTOMER MANAGER, DISCOUNT (R/c), SUB TOTAL, TAX VALUE, GRAND TOTAL, STATUS, PROJECT REGION, ORIGINATOR REGION, PROJECT, SPECIFIER, RESPONSIBLE REP, FOLLOW UP' + "\n";
              var n = 0;
              for (var q in this.quoteList) {
                var projectRegion = '-';
                if (this.quoteList[q].project_region != null) {
                  projectRegion = this.quoteList[q].project_region.replace(/,/g, ' | ')
                }

                reportData += this.quoteList[q].quote_date + ',';
                reportData += this.quoteList[q].quote_no + ',';
                reportData += this.quoteList[q].orig_type + ',';
                reportData += this.quoteList[q].orig_name + ',';
                reportData += this.quoteList[q].customer_type + ',';
                reportData += this.quoteList[q].customer_name + ',';
                reportData += this.quoteList[q].customer_manager + ',';
                reportData += 'R' + this.quoteList[q].discount_val + ',';
                reportData += 'R' + this.quoteList[q].pricing_subtotal + ',';
                reportData += 'R' + this.quoteList[q].pricing_vat + ',';
                reportData += 'R' + this.quoteList[q].pricing_total + ',';
                reportData += this.quoteList[q].status + ',';
                reportData += projectRegion + ',';
                reportData += this.quoteList[q].originator_region + ',';
                reportData += this.quoteList[q].project.replace(/,/g, ' | ') + ',';
                reportData += this.quoteList[q].specifier + ',';
                reportData += this.quoteList[q].responsible_representative.replace(/,/g, ' | ') + ',';
                reportData += this.quoteList[q].pmoc + ',';
                reportData += "\n";                
              }
              var reportDownload = document.createElement('a');
              reportDownload.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(reportData));
              reportDownload.setAttribute('download', 'quotereport.csv');
              reportDownload.click();
            }
        },
        computed: {
          ...mapGetters([
            'objAuthorize',
            'quoteList'
          ])
        },
	}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>